import { RRule, Weekday } from 'rrule';

export namespace UtilsService {
  export function binaryToDecimal(str: string) {
    return parseInt(str.replace(/[^01]/gi, ''), 2);
  }

  export function formatBytes(bytes: number, precision = 2) {
    if (bytes === 0) {
      return '0 KB';
    }

    const coefficient = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const fractionDigits = precision < 0 ? 0 : precision;

    const i = Math.floor(Math.log(bytes) / Math.log(coefficient));

    return (
      parseFloat((bytes / Math.pow(coefficient, i)).toFixed(fractionDigits)) +
      ' ' +
      sizes[i]
    );
  }

  export function getDaysOfWeek(days: number) {
    if (days === 0) {
      return null;
    }
    return days
      .toString(2)
      .split('')
      .reverse()
      .reduce((datum: Weekday[], next: string, index: number) => {
        if (next === '1') {
          switch (index) {
            case 0:
              datum.push(RRule.MO);
              break;
            case 1:
              datum.push(RRule.TU);
              break;
            case 2:
              datum.push(RRule.WE);
              break;
            case 3:
              datum.push(RRule.TH);
              break;
            case 4:
              datum.push(RRule.FR);
              break;
            case 5:
              datum.push(RRule.SA);
              break;
            case 6:
              datum.push(RRule.SU);
              break;
          }
        }
        return datum;
      }, []);
  }
}
